import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AuthService } from '../../../core/services/auth.service';
import { AutoUnsubscribe } from '../../../core/decorators/auto-unsubscribe';
import { GlobalsService } from '../../../core/services/globals.service';

@Component({
    selector: 'calendario',
    templateUrl: './calendario.component.html',
    styleUrls: ['./calendario.component.scss']
})
@AutoUnsubscribe()
export class CalendarioComponent implements OnInit {

    @Input() formulario: FormGroup;
    @Input() controlGroup?: string;
    @Input() controlName: string;
    @Input() timeOnly: boolean = false;
    @Input() showButtonBar = true;
    @Input() classError = false;
    @Input() showTime = false;
    @Input() yearMin: string = '01/01/1990';
    @Input() yearMax: string = '12/31/2050';
    @Input() stepMinute: number = 1;
    @Input() clearButtonStyleClass: string = 'ui-button-secondary';
    @Input() todayButtonStyleClass: string = 'ui-button-secondary';
    @Input() styleClass: 'custom' | 'default' | 'default-100' = 'default';
    @Input() disabled = false;
    @Input() editable = true;
    minDateValue: any;
    maxDateValue: any;
    calculateDateIni: number;
    calculateDateFin: number;
    yearRange = '';
    idioma: any;
    timeVal: any;
    constructor(private _globals: GlobalsService, private authService: AuthService) {
        this.idioma = this.authService.getCalendarLocale();
    }

    ngOnInit() {
        // Correccion para aplicar valores por defecto calendar de solo hora
        if (this.timeOnly) {
            try {
                this.timeVal = this.formulario.get(this.controlName).value;
            } catch (e) {
                this.timeVal = new Date();
            }
        }
        this.calculateDateIni = new Date(this.yearMin).getFullYear();
        this.calculateDateFin = new Date(this.yearMax).getFullYear();
        this.yearRange = `${this.calculateDateIni}:${this.calculateDateFin}`;
        this.minDateValue = this._globals.getDateFormat(new Date(this.yearMin));
        this.maxDateValue = this._globals.getDateFormat(new Date(this.yearMax));
    }
    getFormat() {
        return 'dd/mm/yy';
    }
    getTime(e) {
        e.preventDefault();
        this.timeVal = new Date();
    }

    backSpacePressed(event: any) {
        if (!this.editable) {
            event.preventDefault();
        }
    }
}
